// extracted by mini-css-extract-plugin
module.exports = {"background":"MentorNotifyModal_background__CRTTv","emailCaptureForm":"MentorNotifyModal_emailCaptureForm__UFEl9","terms":"MentorNotifyModal_terms__Um21a"};